/*
    Add here your own custom javascript
*/
document.querySelectorAll('.splide.mx-n3:not(.is-initialized)').forEach(function (el) {
    new Splide(el, {
        type: 'slide',
        perPage: 4,
        gap: '1.5rem',
        arrows: true,
        pagination: false,
        rewind: true,
        breakpoints: {
            992: { perPage: 3, gap: '1rem' },
            768: { perPage: 2, gap: '1rem' },
            576: { perPage: 1, gap: '0.75rem', padding: { right: '3rem' }, arrows: false }
        }
    }).mount()
})
/* ============================================================
   Popup de salida — Comunidad Adhara (WhatsApp)
   Se muestra SOLO en /collections/rutinas-profesionales, cuando
   el usuario está por irse sin haber completado una compra.
   No corre en ninguna otra página del sitio.
   ============================================================ */
;(function () {
  if (window.__adharaExitPopupInit) return
  window.__adharaExitPopupInit = true

  var TARGET_PATH = '/collections/rutinas-profesionales'
  var WHATSAPP_LINK = 'https://chat.whatsapp.com/Gc1wjplyklpBYCnQ9xTKtU?s=cl&p=i&mlu=4&ilr=4'
  var STORAGE_JOINED = 'adhara_popup_joined'
  var STORAGE_LAST_SHOWN = 'adhara_popup_last_shown'
  var COOLDOWN_DAYS = 7
  var ARM_DELAY_MS = 5000

  function isTargetPage () {
    return location.pathname.replace(/\/$/, '') === TARGET_PATH
  }

  function alreadyHandled () {
    try {
      if (localStorage.getItem(STORAGE_JOINED) === '1') return true
      var last = parseInt(localStorage.getItem(STORAGE_LAST_SHOWN) || '0', 10)
      if (last && (Date.now() - last) < COOLDOWN_DAYS * 24 * 60 * 60 * 1000) return true
    } catch (e) {}
    return false
  }

  if (!isTargetPage()) return
  if (alreadyHandled()) return

  function track (eventName, detail) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, detail || {})
      }
    } catch (e) {}
  }

  function loadPoppins () {
    if (document.getElementById('adhara-xp-font')) return
    var link = document.createElement('link')
    link.id = 'adhara-xp-font'
    link.rel = 'stylesheet'
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap'
    document.head.appendChild(link)
  }

  function injectStyles () {
    if (document.getElementById('adhara-xp-styles')) return
    var css = '.adhara-xp-overlay{position:fixed;inset:0;background:rgba(46,38,30,.45);display:none;align-items:center;justify-content:center;padding:20px;z-index:99999;}' +
      '.adhara-xp-overlay.is-open{display:flex;}' +
      '.adhara-xp-card{position:relative;width:100%;max-width:440px;max-height:92vh;overflow-y:auto;background:#FBF6EE;border-radius:24px;box-shadow:0 30px 60px -20px rgba(60,45,35,.35);padding:38px 32px 30px;font-family:"Poppins",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#2E2A25;text-align:left;}' +
      '.adhara-xp-close{position:absolute;top:14px;right:14px;width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,.7);border:1px solid #E1D3C1;display:flex;align-items:center;justify-content:center;font-size:16px;color:#8A7C6D;cursor:pointer;line-height:1;}' +
      '.adhara-xp-brand{font-size:11px;font-weight:600;letter-spacing:.18em;color:#A2645A;text-transform:uppercase;margin:0 0 16px;}' +
      '.adhara-xp-brand small{display:block;font-size:9.5px;letter-spacing:.1em;color:#B4A695;font-weight:400;margin-top:3px;text-transform:none;}' +
      '.adhara-xp-headline{font-size:21px;font-weight:600;line-height:1.32;margin:0 0 12px;}' +
      '.adhara-xp-body{font-size:13.5px;font-weight:300;color:#8A7C6D;line-height:1.6;margin:0 0 20px;}' +
      '.adhara-xp-benefits{display:flex;gap:8px;margin:0 0 22px;flex-wrap:wrap;}' +
      '.adhara-xp-benefits span{background:#211C17;color:#FBF6EE;font-size:12px;font-weight:500;padding:9px 16px;border-radius:10px;white-space:nowrap;}' +
      '.adhara-xp-cta{display:flex;align-items:center;justify-content:center;gap:8px;background:#A2645A;color:#FBF3EF;font-family:inherit;font-size:13px;font-weight:600;letter-spacing:.05em;padding:15px 24px;border-radius:100px;text-decoration:none;box-shadow:0 14px 26px -10px rgba(162,100,90,.55);}' +
      '.adhara-xp-trust{font-size:11px;color:#B4A695;letter-spacing:.03em;margin:14px 0 0;font-weight:400;text-align:center;}' +
      '.adhara-xp-social{display:flex;align-items:center;justify-content:center;gap:11px;margin:18px 0 0;}' +
      '.adhara-xp-avatars{display:flex;}' +
      '.adhara-xp-avatars span{width:26px;height:26px;border-radius:50%;border:2px solid #FBF6EE;display:flex;align-items:center;justify-content:center;margin-left:-9px;background:linear-gradient(160deg,#DCAFA3,#C48B82);}' +
      '.adhara-xp-avatars span:first-child{margin-left:0;}' +
      '.adhara-xp-avatars svg{width:12px;height:12px;}' +
      '.adhara-xp-social-text{line-height:1.35;}' +
      '.adhara-xp-social-text .count{display:block;font-size:12.5px;font-weight:600;color:#2E2A25;}' +
      '.adhara-xp-social-text .label{display:block;font-size:10.5px;font-weight:300;color:#B4A695;}' +
      '.adhara-xp-dismiss{display:block;margin:16px auto 0;background:none;border:none;font-family:inherit;font-size:11px;color:#B4A695;text-decoration:underline;text-underline-offset:3px;cursor:pointer;}' +
      '@media (max-width:480px){.adhara-xp-card{padding:30px 22px 24px;border-radius:20px;}.adhara-xp-headline{font-size:18px;}}'
    var style = document.createElement('style')
    style.id = 'adhara-xp-styles'
    style.textContent = css
    document.head.appendChild(style)
  }

  var avatarSvg = '<svg viewBox="0 0 24 24" fill="#FBF6EE"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8"/></svg>'

  function buildPopup () {
    var overlay = document.createElement('div')
    overlay.className = 'adhara-xp-overlay'
    overlay.setAttribute('role', 'dialog')
    overlay.setAttribute('aria-modal', 'true')
    overlay.innerHTML =
      '<div class="adhara-xp-card">' +
        '<button type="button" class="adhara-xp-close" aria-label="Cerrar">&times;</button>' +
        '<div class="adhara-xp-brand">Comunidad Adhara<small>Tu Salón en Casa</small></div>' +
        '<h3 class="adhara-xp-headline">¿Aún no sabes qué necesita tu cabello? 💖</h3>' +
        '<p class="adhara-xp-body">Únete gratis y aprende de un estilista profesional a conocer tu cabello, y trátalo de manera profesional, paso a paso, desde casa.</p>' +
        '<div class="adhara-xp-benefits"><span>Tips</span><span>Rutinas</span><span>Resultados</span></div>' +
        '<a href="' + WHATSAPP_LINK + '" target="_blank" rel="noopener noreferrer" class="adhara-xp-cta" id="adharaXpCta">UNIRME GRATIS 💖</a>' +
        '<p class="adhara-xp-trust">Gratis · Contenido profesional · Consultas con expertas</p>' +
        '<div class="adhara-xp-social">' +
          '<div class="adhara-xp-avatars"><span>' + avatarSvg + '</span><span>' + avatarSvg + '</span><span>' + avatarSvg + '</span></div>' +
          '<div class="adhara-xp-social-text"><span class="count">+26.500 clientas felices</span><span class="label">ya son parte de Comunidad Adhara</span></div>' +
        '</div>' +
        '<button type="button" class="adhara-xp-dismiss">Ahora no, gracias</button>' +
      '</div>'
    document.body.appendChild(overlay)

    function closePopup (reason) {
      overlay.classList.remove('is-open')
      try { localStorage.setItem(STORAGE_LAST_SHOWN, String(Date.now())) } catch (e) {}
      track('popup_closed', { reason: reason })
    }

    overlay.querySelector('.adhara-xp-close').addEventListener('click', function () { closePopup('close_x') })
    overlay.querySelector('.adhara-xp-dismiss').addEventListener('click', function () { closePopup('dismiss_link') })
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup('backdrop') })
    overlay.querySelector('#adharaXpCta').addEventListener('click', function () {
      try { localStorage.setItem(STORAGE_JOINED, '1') } catch (e) {}
      track('popup_cta_click', {})
    })

    overlay.closeFn = closePopup
    return overlay
  }

  var popupEl = null
  var hasFired = false

  function fireExitPopup (reason) {
    if (hasFired || !popupEl || alreadyHandled()) return
    if (document.querySelector('.offcanvas.show, .modal.show')) return
    hasFired = true
    requestAnimationFrame(function () { popupEl.classList.add('is-open') })
    track('popup_shown', { trigger: reason, path: location.pathname })
  }

  // Ayuda para probarlo manualmente desde la consola: adharaTestExitPopup()
  window.adharaTestExitPopup = function () { if (popupEl) fireExitPopup('manual_test') }

  setTimeout(function () {
    if (alreadyHandled()) return

    loadPoppins()
    injectStyles()
    popupEl = buildPopup()

    var isDesktopPointer = window.matchMedia('(pointer: fine)').matches

    if (isDesktopPointer) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) fireExitPopup('mouseleave_top')
      })
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return
      if (popupEl.classList.contains('is-open')) {
        popupEl.closeFn('escape_close')
        return
      }
      if (isDesktopPointer && !document.querySelector('.offcanvas.show, .modal.show')) {
        fireExitPopup('escape')
      }
    })

    if (window.matchMedia('(max-width: 991px)').matches) {
      try {
        history.pushState({ adharaGuard: true }, '')
        var onPop = function () {
          window.removeEventListener('popstate', onPop)
          if (!alreadyHandled()) {
            fireExitPopup('mobile_back')
            history.pushState({ adharaGuard: true }, '')
          }
        }
        window.addEventListener('popstate', onPop)
      } catch (e) {}
    }
  }, ARM_DELAY_MS)
})()
/* ============================================================
   Espaciado mobile: evita que el botón de WhatsApp (PushDaddy)
   y la burbuja de Chat de Shopify se sobrepongan a la barra fija
   "Agregar al carrito" (#sticky-atc-bar) en pantallas chicas.
   Solo actúa cuando esa barra está visible — el resto del tiempo
   el botón de WhatsApp queda donde siempre.
   ============================================================ */
;(function () {
  if (document.getElementById('adhara-sticky-atc-spacing')) return
  var css = '@media (max-width: 991px) {' +
    'body:has(#sticky-atc-bar.visible) #pushdaddy-button { bottom: 80px !important; }' +
    '#sticky-atc-bar { padding-right: 112px !important; }' +
    '}'
  var style = document.createElement('style')
  style.id = 'adhara-sticky-atc-spacing'
  style.textContent = css
  document.head.appendChild(style)
})()
/* ============================================================
   Fix: el carrusel "Más Vendidos" del home no se podía arrastrar
   ni deslizar (se quedaba estático).

   Causa confirmada probando en vivo en somosadhara.cl:
   al arrastrar, el navegador intentaba iniciar SU PROPIO gesto
   nativo de "arrastrar imagen/enlace" (el mismo con el que uno
   arrastraría una foto o un link a otra pestaña). Ese gesto nativo
   capturaba el mouse antes de que Splide (la librería del carrusel)
   alcanzara a registrar el arrastre, así que el carrusel nunca se
   movía. Confirmé esto viendo que el navegador soltaba un evento
   "dragstart" no bloqueado apenas se iniciaba el gesto, y que al
   bloquear ese gesto nativo el carrusel volvía a deslizar
   perfectamente (probado repetidas veces).

   Esta corrección bloquea ese gesto nativo SOLO dentro del
   carrusel "Más Vendidos" (selector .splide.mx-n3), en cualquier
   imagen o enlace que tenga ahora o se agregue después (por
   ejemplo si las imágenes cargan de forma diferida). No toca la
   configuración de Splide que ya está arriba en este archivo.
   ============================================================ */
;(function () {
  if (window.__adharaCarouselDragFix) return
  window.__adharaCarouselDragFix = true

  document.querySelectorAll('.splide.mx-n3').forEach(function (el) {
    // 1) Evita que el propio "mousedown" dispare el arrastre nativo
    //    de imagen/enlace del navegador (la causa real del problema).
    el.addEventListener('mousedown', function (e) {
      if (e.target.closest('img, a')) e.preventDefault()
    }, false)

    // 2) Refuerzo: si de todos modos el navegador intenta iniciar
    //    su arrastre nativo, lo cancela igual.
    el.addEventListener('dragstart', function (e) {
      e.preventDefault()
    }, true)
  })

  // 3) Refuerzo por atributo/CSS para imágenes y enlaces ya
  //    presentes, más protección contra el menú de "guardar imagen"
  //    al mantener presionado en celular.
  document.querySelectorAll('.splide.mx-n3 img, .splide.mx-n3 a').forEach(function (node) {
    node.setAttribute('draggable', 'false')
  })
  if (!document.getElementById('adhara-carousel-drag-fix-styles')) {
    var style = document.createElement('style')
    style.id = 'adhara-carousel-drag-fix-styles'
    style.textContent =
      '.splide.mx-n3 img,.splide.mx-n3 a{-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;}' +
      // 4) En celular: le dice al navegador "el gesto horizontal es para
      //    deslizar el carrusel, solo el vertical es para hacer scroll
      //    de la página". Sin esto, en algunos teléfonos el navegador
      //    decide por su cuenta que CUALQUIER arrastre es scroll de
      //    página y nunca le pasa el gesto a la librería del carrusel.
      '.splide.mx-n3,.splide.mx-n3 .splide__track,.splide.mx-n3 .splide__list,.splide.mx-n3 img{touch-action:pan-y;}'
    document.head.appendChild(style)
  }
})()
/* ============================================================
   FIX 1: en la página "Rutinas Profesionales", los botones
   "Quiero el kit ..." agregaban el producto con un envío de
   formulario normal (recarga completa de página): al hacer
   clic, el cliente salía de golpe de la página persuasiva y
   caía en la página pelada del carrito ("Tu Carrito"), sin
   pasar por el carrito lateral que se usa en el resto del
   sitio. Confirmado probando en vivo: el clic navega fuera de
   la página en vez de agregar el producto sin interrumpir.
   Esto es una causa muy probable del alto abandono de carrito
   en esta página en comparación con el resto del sitio.

   Esta corrección conecta esos 3 botones al mismo mecanismo de
   "agregar al carrito" que ya usa el resto del sitio (la función
   global window.onSubmitAtcForm, la misma de las páginas de
   producto y de las colecciones normales): agrega el producto
   por AJAX sin recargar la página, y abre el carrito lateral
   deslizante para que la clienta pueda seguir viendo la página
   o ir directo a pagar.
   ============================================================ */
;(function () {
  if (window.__adharaArpAtcFix) return
  window.__adharaArpAtcFix = true

  document.querySelectorAll('.arp-kit__form').forEach(function (form) {
    if (form.dataset.adharaAtcWired) return
    form.dataset.adharaAtcWired = '1'

    var btn = form.querySelector('button[type="submit"]')
    if (btn) {
      if (!btn.classList.contains('btn-atc')) btn.classList.add('btn-atc')
      if (!btn.dataset.textAddToCart) btn.dataset.textAddToCart = btn.innerHTML
    }

    form.addEventListener('submit', function (e) {
      if (typeof window.onSubmitAtcForm === 'function') {
        window.onSubmitAtcForm(form, e)
      }
    })
  })
})()

/* ============================================================
   FIX 2: agrega las estrellas de reseñas (Loox) a cada kit de
   la página "Rutinas Profesionales". Estas tarjetas son una
   sección hecha a medida (no la tarjeta de producto estándar
   del tema), así que Loox no las detecta ni las dibuja solo.

   Para no depender de números fijos que con el tiempo queden
   desactualizados, esta corrección busca el rating real de
   cada producto consultando su propia página de producto (la
   misma que ya usa Loox) y arma las estrellas con esos datos,
   siempre al día, con el mismo estilo visual que usa el resto
   del sitio.
   ============================================================ */
;(function () {
  if (window.__adharaArpRatingsFix) return
  window.__adharaArpRatingsFix = true

  function starIcon(filled) {
    return (
      '<svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="' +
      (filled ? 'full' : 'empty') +
      '" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>'
    )
  }

  function buildRatingHTML(rating, raters) {
    var filledCount = Math.round(parseFloat(rating)) || 0
    var stars = ''
    for (var i = 0; i < 5; i++) stars += starIcon(i < filledCount)
    // data-rating-upgraded="1" evita que el script de Loox (que sí
    // sigue activo en esta página) intente "mejorar" esta insignia
    // de nuevo y termine agregando una segunda fila de estrellas
    // duplicada (se probó en vivo: sin este atributo, Loox duplica
    // el contenido apenas la insignia entra en pantalla).
    return (
      '<div class="loox-rating" data-rating="' + rating + '" data-raters="' + raters + '" ' +
      'title="' + raters + ' reviews" aria-label="' + raters + ' reviews" role="figure" ' +
      'data-rating-upgraded="1">' +
      '<div class="loox-rating-content">' + stars +
      '<span class="loox-rating-label" aria-hidden="true">&nbsp;(' + raters + ')</span>' +
      '</div></div>'
    )
  }

  document.querySelectorAll('.arp-kit').forEach(function (kit) {
    if (kit.querySelector('.loox-rating')) return
    var link = kit.querySelector('.arp-kit__title-link')
    var titleEl = kit.querySelector('.arp-kit__title')
    var pidInput = kit.querySelector('.arp-kit__form [name="product-id"]')
    var productId = pidInput ? pidInput.value : null
    if (!link || !titleEl) return

    fetch(link.getAttribute('href'), { credentials: 'omit' })
      .then(function (res) { return res.text() })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html')
        // Primero intenta la insignia con el mismo product-id (así no
        // se confunde con la de otro producto mostrado en esa página,
        // por ejemplo en un bloque de "también te puede interesar").
        // Si esa página no marca el id (pasa en algunas fichas), usa
        // la insignia sin id como respaldo.
        var source = null
        if (productId) source = doc.querySelector('.loox-rating[data-id="' + productId + '"]')
        if (!source) source = doc.querySelector('.loox-rating[data-rating]:not([data-id])')
        if (!source) return
        var rating = source.getAttribute('data-rating')
        var raters = source.getAttribute('data-raters')
        if (!rating || !raters) return
        var wrap = document.createElement('div')
        wrap.className = 'arp-kit__rating mb-2'
        wrap.innerHTML = buildRatingHTML(rating, raters)
        titleEl.insertAdjacentElement('afterend', wrap)
      })
      .catch(function () {})
  })
})()

/* =====================================================================
   ADHARA · Aviso de PRE-VENTA en todos los botones de "Agregar"
   ---------------------------------------------------------------------
   Problema: el aviso "¿Aceptas que este producto se retrasará su envío
   hasta X?" solo existe en la ficha de producto (campo de personalización
   del tema, propiedad "¡PRE-VENTA!📦"). Los botones de colección, "Más
   Vendidos", "Te podría gustar" del carrito lateral, etc. agregaban el
   producto sin aviso y sin dejar registro en el pedido.

   Qué hace este bloque:
   1. Antes de agregar desde CUALQUIER botón que no sea la ficha, revisa
      (leyendo la propia ficha del producto) si está en preventa.
   2. Si lo está, muestra un modal con la fecha y pide aceptar.
   3. Al aceptar, agrega la MISMA propiedad que agrega la ficha, así la
      aceptación queda en el carrito, checkout, correo y pedido.
   4. Muestra un sello "PRE-VENTA · Despacho desde el X" en las tarjetas.

   La fecha se lee siempre de la ficha: si cambias la fecha o quitas la
   preventa en el editor de temas, esto se actualiza solo (caché 20 min).
   Pegar AL FINAL de assets/custom.js, sin borrar nada de lo existente.
   ===================================================================== */
;(function adharaPreventaGuard() {
  if (window.__adharaPreventaGuard) return;
  window.__adharaPreventaGuard = true;

  var PROP_PREFIX = 'properties[¡PRE-VENTA';
  var CACHE_TTL = 20 * 60 * 1000; // 20 minutos
  var mem = {};      // handle -> { name, value } | null
  var pending = {};  // handle -> Promise

  /* ---------- Detección de preventa (leyendo la ficha) ---------- */
  function cacheGet(handle) {
    if (handle in mem) return { hit: true, data: mem[handle] };
    try {
      var raw = sessionStorage.getItem('adharaPre:' + handle);
      if (raw) {
        var o = JSON.parse(raw);
        if (Date.now() - o.t < CACHE_TTL) { mem[handle] = o.d; return { hit: true, data: o.d }; }
      }
    } catch (e) {}
    return { hit: false };
  }
  function cacheSet(handle, data) {
    mem[handle] = data;
    try { sessionStorage.setItem('adharaPre:' + handle, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
  }
  function getPreventa(handle) {
    var c = cacheGet(handle);
    if (c.hit) return Promise.resolve(c.data);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var data = null;
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inp = doc.querySelector('input[name^="' + PROP_PREFIX + '"]');
          if (inp) data = { name: inp.getAttribute('name'), value: inp.value };
        }
        cacheSet(handle, data);
        return data;
      })
      .catch(function () { return null; }) // ante error de red, no bloquear la venta
      .then(function (d) { delete pending[handle]; return d; });
    return pending[handle];
  }

  function handleFrom(el) {
    var node = el;
    while (node && node !== document.body) {
      var a = node.querySelector && node.querySelector('a[href*="/products/"]');
      if (a) {
        var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
        return m ? decodeURIComponent(m[1]) : null;
      }
      node = node.parentElement;
    }
    return null;
  }

  function fechaDe(value) {
    var m = (value || '').match(/hasta (?:el )?(.+?)\s*\??$/i);
    return m ? m[1] : null;
  }

  /* ---------- Estilos ---------- */
  var css = '' +
    '.adh-pre-ov{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .2s}' +
    '.adh-pre-ov.show{opacity:1}' +
    '.adh-pre-box{background:#fff;border-radius:14px;max-width:420px;width:100%;padding:26px 22px 20px;box-shadow:0 20px 60px rgba(0,0,0,.25);border-top:4px solid #c9a84c;text-align:center;font-family:inherit;transform:translateY(10px);transition:transform .2s}' +
    '.adh-pre-ov.show .adh-pre-box{transform:none}' +
    '.adh-pre-ico{font-size:34px;line-height:1;margin-bottom:8px}' +
    '.adh-pre-tag{display:inline-block;background:#fdf6e3;color:#9a7d3a;font-weight:800;font-size:12px;letter-spacing:.08em;text-transform:uppercase;padding:4px 10px;border-radius:20px;margin-bottom:10px}' +
    '.adh-pre-ttl{font-size:19px;font-weight:800;margin:0 0 8px;color:#111}' +
    '.adh-pre-txt{font-size:14.5px;color:#444;margin:0 0 6px;line-height:1.45}' +
    '.adh-pre-date{font-size:17px;font-weight:800;color:#b8860b}' +
    '.adh-pre-note{font-size:12.5px;color:#777;margin:10px 0 18px}' +
    '.adh-pre-btn{display:block;width:100%;border:0;border-radius:8px;padding:13px 14px;font-size:15px;font-weight:700;cursor:pointer}' +
    '.adh-pre-ok{background:#000;color:#fff;margin-bottom:8px}' +
    '.adh-pre-no{background:transparent;color:#666;text-decoration:underline;font-weight:500}' +
    '.adh-pre-badge{display:inline-block;background:#fdf6e3;border-left:3px solid #c9a84c;color:#7a5d12;font-size:12px;font-weight:700;padding:4px 8px;border-radius:4px;margin:0 0 8px;line-height:1.3}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---------- Modal ---------- */
  function confirmar(pre) {
    return new Promise(function (resolve) {
      var fecha = fechaDe(pre.value);
      var ov = document.createElement('div');
      ov.className = 'adh-pre-ov';
      ov.setAttribute('role', 'dialog');
      ov.setAttribute('aria-modal', 'true');
      ov.innerHTML =
        '<div class="adh-pre-box">' +
          '<div class="adh-pre-ico">📦</div>' +
          '<div class="adh-pre-tag">Producto en pre-venta</div>' +
          '<p class="adh-pre-ttl">Este kit se despacha más adelante</p>' +
          (fecha
            ? '<p class="adh-pre-txt">Aseguras tu kit hoy al precio actual y lo enviamos a partir del</p><div class="adh-pre-date">' + fecha + '</div>'
            : '<p class="adh-pre-txt">' + pre.value + '</p>') +
          '<p class="adh-pre-note">Si tu pedido incluye otros productos, todo se despacha junto en esa fecha.</p>' +
          '<button type="button" class="adh-pre-btn adh-pre-ok">Sí, acepto la fecha y lo quiero</button>' +
          '<button type="button" class="adh-pre-btn adh-pre-no">No, gracias</button>' +
        '</div>';
      document.body.appendChild(ov);
      requestAnimationFrame(function () { ov.classList.add('show'); });
      var okBtn = ov.querySelector('.adh-pre-ok');
      okBtn.focus();
      function close(v) {
        document.removeEventListener('keydown', onKey);
        ov.classList.remove('show');
        setTimeout(function () { ov.remove(); }, 200);
        resolve(v);
      }
      function onKey(e) { if (e.key === 'Escape') close(false); }
      document.addEventListener('keydown', onKey);
      okBtn.addEventListener('click', function () { close(true); });
      ov.querySelector('.adh-pre-no').addEventListener('click', function () { close(false); });
      ov.addEventListener('click', function (e) { if (e.target === ov) close(false); });
    });
  }

  /* ---------- Interceptar "Agregar al carrito" ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.adhPrePass === '1') { delete form.dataset.adhPrePass; return; }   // ya revisado
    if (form.querySelector('[name^="' + PROP_PREFIX + '"]')) return;                   // ficha: ya tiene su aviso
    var handle = handleFrom(form);
    if (!handle) return;

    var c = cacheGet(handle);
    if (c.hit && !c.data) return; // sabemos que NO es preventa: sigue normal, sin demora

    e.preventDefault();
    e.stopImmediatePropagation(); // evita que corra onSubmitAtcForm del tema por ahora

    var btn = form.querySelector('.btn-atc, button[type="submit"], button');
    if (btn) btn.style.opacity = '.6';

    getPreventa(handle).then(function (pre) {
      if (btn) btn.style.opacity = '';
      if (!pre) { form.dataset.adhPrePass = '1'; form.requestSubmit(); return; }
      return confirmar(pre).then(function (ok) {
        if (!ok) return;
        var hid = form.querySelector('input[data-adh-pre]');
        if (!hid) {
          hid = document.createElement('input');
          hid.type = 'hidden';
          hid.setAttribute('data-adh-pre', '1');
          form.appendChild(hid);
        }
        hid.name = pre.name;
        hid.value = pre.value;  // mismo texto que guarda la ficha
        form.dataset.adhPrePass = '1';
        form.requestSubmit();
      });
    });
  }, true);

  /* ---------- Pre-carga al acercar el dedo/mouse (sin demora al clic) ---------- */
  function warm(e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || form.querySelector('[name^="' + PROP_PREFIX + '"]')) return;
    var h = handleFrom(form);
    if (h) getPreventa(h);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });

  /* ---------- Sello "PRE-VENTA" en las tarjetas de producto ---------- */
  var queue = [], active = 0;
  function pump() {
    while (active < 3 && queue.length) {
      var card = queue.shift();
      active++;
      paint(card).then(function () { active--; pump(); });
    }
  }
  function paint(card) {
    var h = handleFrom(card.querySelector('a[href*="/products/"]') || card);
    if (!h) return Promise.resolve();
    return getPreventa(h).then(function (pre) {
      if (!pre || card.querySelector('.adh-pre-badge')) return;
      var fecha = fechaDe(pre.value);
      var b = document.createElement('div');
      b.className = 'adh-pre-badge';
      b.textContent = '📦 PRE-VENTA' + (fecha ? ' · Despacho desde el ' + fecha : '');
      var price = card.querySelector('.product-item-price');
      if (price) price.parentNode.insertBefore(b, price);
      else card.appendChild(b);
    });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { io.unobserve(en.target); queue.push(en.target); pump(); }
    });
  }, { rootMargin: '200px' }) : null;
  function scan() {
    document.querySelectorAll('.product-item').forEach(function (card) {
      if (card.dataset.adhPreSeen) return;
      if (!card.querySelector('form[action*="/cart/add"]')) return;
      card.dataset.adhPreSeen = '1';
      if (io) io.observe(card); else { queue.push(card); pump(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // el carrito lateral y los carruseles cargan tarjetas después
  new MutationObserver(function () { clearTimeout(scan._t); scan._t = setTimeout(scan, 300); })
    .observe(document.body, { childList: true, subtree: true });
})();

;(function adharaCartBoost() {
  /* ==========================================================
     ADHARA · Carrito que vende más (oct. 2026)
     Funciona en el carrito lateral (slide) y en la página /cart.
     Nunca en la ficha de producto (ahí la clienta aún decide).
     Muestra UNA oferta a la vez, para no saturar:

     A) Upgrade Kit básico → Kit Premium
        Si el carrito tiene el Kit Alisado en Casa básico (y no
        el Premium ni la mascarilla): felicita, ofrece cambiarlo
        pagando solo la diferencia y dice cómo queda el envío.
        Un clic: quita el básico, agrega el Premium (misma cantidad
        y misma propiedad de PRE-VENTA) y el carrito se actualiza.

     B) Envío gratis
        Si no hay upgrade que ofrecer y el carrito está bajo el
        monto de envío gratis (se lee de la barra del tema): dice
        cuánto falta y sugiere hasta 4 productos idóneos (protector
        térmico primero) en una fila deslizable estilo Mercado Libre,
        con una reseña verificada real de Loox de cada uno.
        Agregar = un clic.

     C) Confianza bajo el botón "Pagar" (reemplaza íconos Kaching)
        Calificación y reseñas verificadas reales (Loox) del producto
        principal del carrito, rotando cada 6 s, + facilidades de
        frase de satisfacción real (SATISFACCION) y sellos (SELLOS),
        ambos editables arriba.

     Todo se lee EN VIVO (precios publicados, stock, preventa,
     monto de envío gratis y reseñas). Si algo cambia en la
     tienda, el texto se actualiza solo.
     ========================================================== */
  if (window.__adhCartBoost) return;
  window.__adhCartBoost = true;

  var BASICO = 'kit-alisado-golden-glow-uso-profesional-140-ml';
  var PREMIUM = 'kit-alisado-en-casa-premium';
  var MASCARA = 'mascarilla-hidratante-golden-glow-500g';
  var PV_NAME = '¡PRE-VENTA!📦';

  /* Sugerencias para el envío gratis, en orden de prioridad.
     "beneficio" = una línea corta; se puede editar libremente. */
  var SUGERENCIAS = [
    { handle: 'dream-hair-protector-termico', beneficio: 'Protege del calor del secador y la plancha, y ayuda a que tu liso dure más' },
    { handle: 'sos-reconstruccion-adhara-professional', beneficio: 'Repara y fortalece en 5 minutos' },
    { handle: 'aceite-milenario', beneficio: 'Brillo y nutrición para puntas secas' },
    { handle: 'shampoo-golden-glow-home-care-300-ml', beneficio: 'Mantiene el brillo de tu cabello en casa' },
    { handle: MASCARA, beneficio: 'Brillo espejo y suavidad de seda' },
    { handle: 'peineta-especial-para-alisados', beneficio: 'Sujeta cada mechón para planchar más fácil' }
  ];
  var MAX_SUGERENCIAS = 4;

  /* ---------- C) Bloque de confianza bajo el botón "Pagar" ----------
     Reemplaza el bloque de íconos de la app PX Trust Badges & Icons.
     Editar aquí libremente. SOLO datos reales y comprobables. */

  /* Satisfacción: reseñas PUBLICADAS en Loox de toda la tienda.
     Verificado 19-oct-2026: 1.099 reseñas · 1.008 de 5★ + 82 de 4★
     = 1.090 de 1.099 → 99% con 4 o 5 estrellas · promedio 4,9.
     Actualizar cada 2-3 meses desde Loox (Reviews → distribución). */
  var SATISFACCION = { pct: 99, total: '1.099', promedio: '4,9' };

  /* Sellos (cada uno respaldado en las fichas del sitio) */
  var SELLOS = [
    { icono: '🏆', texto: 'Ganador DBS Beauty Innovación 2024' },
    { icono: '🐰', texto: 'Sin testeo animal' },
    { icono: '🌿', texto: 'Sin formol · Reg. ISP' },
    { icono: '💳', texto: 'Hasta 3 cuotas sin interés' },   /* confirmar: 3 (VENTI) o 6 */
    { icono: '🔒', texto: 'Pago 100% seguro' }
  ];
  var OCULTAR_KACHING = true; /* esconde los íconos de la app PX Trust Badges & Icons (clases "kaching-icon-block") si siguiera activa */
  var KEYWORDS = /brill|calor|plancha|secador|frizz|liso|alisad|suave|sedos|repar|hidrat/i;
  var PRIMERA_PERSONA = /\bmi (pelo|cabello)\b|\bme (dej|qued|encant)/i;   /* "mi pelo quedó…" */
  var DE_ESTILISTA = /\bclient[ae]s?\b|\bmi sal[oó]n\b/i;                 /* reseñas de profesionales */
  /* Limpia espacios y comillas que ya traiga la reseña (para no duplicarlas) */
  function cleanReview(body) {
    return String(body).replace(/\s+/g, ' ').trim().replace(/^["“”'«»]+|["“”'«»]+$/g, '').trim();
  }
  /* Puntaje de una reseña: habla del resultado, en primera persona, largo legible */
  function scoreReview(body) {
    return (KEYWORDS.test(body) ? 10 : 0) + (PRIMERA_PERSONA.test(body) ? 6 : 0) -
      (DE_ESTILISTA.test(body) ? 12 : 0) + Math.min(body.length, 120) / 20;
  }

  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJSON(url) { return fetch(url).then(function (r) { return r.json(); }); }

  /* ---------- datos del upgrade ---------- */
  var upPromise = null;
  function loadUpgrade() {
    if (upPromise) return upPromise;
    upPromise = Promise.all([
      getJSON('/products/' + BASICO + '.js'),
      getJSON('/products/' + PREMIUM + '.js'),
      getJSON('/products/' + MASCARA + '.js').catch(function () { return null; }),
      fetch('/products/' + PREMIUM).then(function (r) { return r.text(); })
    ]).then(function (res) {
      var b = res[0], p = res[1], m = res[2];
      var doc = new DOMParser().parseFromString(res[3], 'text/html');
      var pvInput = doc.querySelector('input[name="properties[' + PV_NAME + ']"]');
      var pVar = p.variants[0], mVar = m ? m.variants[0] : null;
      return {
        basicoIds: b.variants.map(function (v) { return v.id; }),
        premiumId: pVar.id,
        premiumAvailable: pVar.available,
        diff: pVar.price - b.variants[0].price,
        mascaraPrice: mVar ? mVar.price : 0,
        mascaraCompare: mVar && mVar.compare_at_price > mVar.price ? mVar.compare_at_price : 0,
        pvValue: pvInput ? pvInput.value : null
      };
    });
    return upPromise;
  }

  /* ---------- datos de una sugerencia (precio, stock, preventa, reseña) ---------- */
  var sugCache = {};
  function loadSug(s) {
    if (sugCache[s.handle]) return sugCache[s.handle];
    var key = 'adhSug:' + s.handle, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 30 * 60 * 1000) {
      sugCache[s.handle] = Promise.resolve(cached.v);
      return sugCache[s.handle];
    }
    sugCache[s.handle] = Promise.all([
      getJSON('/products/' + s.handle + '.js'),
      fetch('/products/' + s.handle).then(function (r) { return r.text(); })
    ]).then(function (res) {
      var p = res[0], v = p.variants.filter(function (x) { return x.available; })[0];
      var doc = new DOMParser().parseFromString(res[1], 'text/html');
      var preventa = !!doc.querySelector('input[name="properties[' + PV_NAME + ']"]');
      /* reseña: 5/5 verificada, largo razonable, que hable del resultado */
      var best = null;
      doc.querySelectorAll('#loox-reviews-feed article.loox-review').forEach(function (a) {
        var body = (a.querySelector('.loox-review-body') || {}).textContent || '';
        var name = (a.querySelector('.loox-reviewer-name') || {}).textContent || '';
        var rating = (a.querySelector('.loox-review-rating') || {}).textContent || '';
        var verified = !!a.querySelector('.loox-review-verified');
        body = cleanReview(body);
        if (rating.trim() !== '5/5' || !verified || body.length < 30 || body.length > 150) return;
        var score = scoreReview(body);
        if (!best || score > best.score) best = { body: body, name: name.trim(), score: score };
      });
      var val = v ? {
        handle: s.handle, beneficio: s.beneficio, title: p.title, url: p.url || ('/products/' + s.handle),
        id: v.id, price: v.price,
        compare: v.compare_at_price > v.price ? v.compare_at_price : 0,
        img: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '',
        preventa: preventa,
        review: best ? { body: best.body, name: best.name } : null
      } : null;
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: val })); } catch (e) {}
      return val;
    }).catch(function () { return null; });
    return sugCache[s.handle];
  }

  /* ---------- monto de envío gratis: se lee de la barra del tema ---------- */
  function freeShipThreshold() {
    var bar = document.querySelector('#cart-goal [aria-valuemax]');
    if (!bar) return 0;
    var n = parseInt(String(bar.getAttribute('aria-valuemax')).replace(/[^\d]/g, ''), 10);
    return n > 0 ? n * 100 : 0; /* a centavos, como cart.js */
  }

  /* ---------- estilos ---------- */
  var css = document.createElement('style');
  /* Estilo "Mercado Libre" con la identidad Adhara:
     tarjetas blancas con sombra suave, títulos Poppins, textos Lato,
     coral #fd9d8f para destacar, café #251a19 para acciones,
     verde solo para "envío gratis" (convención que todas reconocen). */
  var F_TIT = "'Poppins', sans-serif", F_TXT = "'Lato', sans-serif";
  css.textContent =
    /* tarjeta base */
    '.adh-card{background:#fff;border:1px solid #ece7e6;border-radius:8px;box-shadow:0 1px 3px rgba(37,26,25,.10);margin:12px 0;font-family:' + F_TXT + ';color:#251a19;overflow:hidden}' +
    '.adh-card__head{display:flex;align-items:center;gap:8px;padding:10px 14px;border-bottom:1px solid #f1eceb;font-family:' + F_TIT + ';font-weight:600;font-size:14px;line-height:1.3}' +
    '.adh-card__body{padding:12px 14px}' +
    '.adh-pill{display:inline-block;font-family:' + F_TXT + ';font-size:11px;font-weight:700;letter-spacing:.3px;text-transform:uppercase;border-radius:4px;padding:2px 7px}' +
    '.adh-pill--coral{background:#fff1ee;color:#c8604f}' +
    '.adh-pill--green{background:#e8f5e9;color:#2e7d32}' +
    /* A) upgrade */
    '.adh-up{border-left:4px solid #fd9d8f}' +
    '.adh-up__title{font-family:' + F_TIT + ';font-size:16px;font-weight:600;margin:0 0 8px;line-height:1.3}' +
    '.adh-up__title b{color:#c8604f;font-weight:600}' +
    '.adh-up__list{margin:0 0 10px;padding:0;list-style:none;font-size:13.5px;line-height:1.4}' +
    '.adh-up__list li{margin:4px 0}' +
    '.adh-up__list s,.adh-fs s{color:#8a7d7b;font-weight:400}' +
    '.adh-up__save{color:#2e7d32;font-weight:700}' +
    '.adh-up__ship{color:#2e7d32;font-weight:700}' +
    '.adh-up__quote{font-size:13px;font-style:italic;line-height:1.4;color:#251a19;background:#f8f9fa;border-radius:6px;padding:8px 10px;margin:0 0 12px}' +
    '.adh-up__quote span{display:block;font-style:normal;font-size:12px;color:#8a7d7b;margin-top:3px}' +
    '.adh-up__btn{display:block;width:100%;border:0;border-radius:6px;background:#251a19;color:#fff;font-family:' + F_TXT + ';font-weight:700;font-size:14px;padding:13px 14px;cursor:pointer}' +
    '.adh-up__btn:hover{background:#3a2b29}' +
    '.adh-up__btn[disabled],.adh-fs__btn[disabled]{opacity:.6;cursor:wait}' +
    /* B) envío gratis */
    '.adh-fs .adh-card__head b{color:#2e7d32;font-weight:600}' +
    '.adh-fs .adh-card__body{padding:12px 0 12px 14px}' +
    '.adh-fs__row{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:0 14px 4px 0;scrollbar-width:none;touch-action:pan-x pan-y}' +
    '.adh-fs__row::-webkit-scrollbar{display:none}' +
    '.adh-fs__card{position:relative;flex:0 0 148px;scroll-snap-align:start;background:#fff;border:1px solid #ece7e6;border-radius:8px;padding:8px;display:flex;flex-direction:column;transition:box-shadow .2s}' +
    '.adh-fs__card:hover{box-shadow:0 4px 12px rgba(37,26,25,.12)}' +
    '.adh-fs__imgwrap{display:block;background:#f8f9fa;border-radius:6px;overflow:hidden}' +
    '.adh-fs__img{display:block;width:100%;height:96px;object-fit:contain}' +
    '.adh-fs__ok{position:absolute;top:12px;left:12px;z-index:1}' +
    '.adh-fs__price{font-family:' + F_TIT + ';font-size:16px;font-weight:600;margin:6px 0 1px}' +
    '.adh-fs__price s{font-family:' + F_TXT + ';font-size:11.5px}' +
    '.adh-fs__name{font-size:12.5px;font-weight:700;color:#251a19;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.7em;line-height:1.35}' +
    '.adh-fs__ben{font-size:11.5px;line-height:1.35;color:#5a4f4e;margin:2px 0 4px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.adh-fs__rev{font-size:11.5px;line-height:1.35;font-style:italic;color:#5a4f4e;margin:0 0 6px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}' +
    '.adh-fs__stars{font-style:normal;color:#e0a800;letter-spacing:-1px}' +
    '.adh-fs__who{font-style:normal;color:#8a7d7b}' +
    '.adh-fs__btn{margin-top:auto;width:100%;border:1.5px solid #251a19;border-radius:6px;background:#fff;color:#251a19;font-family:' + F_TXT + ';font-weight:700;font-size:13px;padding:7px 8px;cursor:pointer}' +
    '.adh-fs__btn:hover{background:#251a19;color:#fff}' +
    '.adh-fs__wrap{position:relative}' +
    '.adh-fs__arrow{display:none;position:absolute;top:38%;z-index:2;width:32px;height:32px;border-radius:50%;border:1px solid #ece7e6;background:#fff;color:#251a19;font-size:18px;line-height:28px;text-align:center;cursor:pointer;box-shadow:0 2px 8px rgba(37,26,25,.16);padding:0}' +
    '.adh-fs__arrow--prev{left:-6px}.adh-fs__arrow--next{right:8px}' +
    '@media (hover:hover) and (pointer:fine){.adh-fs__arrow{display:block}.adh-fs__arrow[hidden]{display:none}}' +
    '.adh-card--page{max-width:640px}' +
    /* C) confianza */
    '.adh-tr{margin:10px 0 0;background:#f8f9fa;border-radius:8px;padding:10px 12px;font-family:' + F_TXT + ';color:#251a19;text-align:left}' +
    '.adh-tr__top{display:flex;align-items:center;gap:8px;margin:0 0 6px}' +
    '.adh-tr__score{font-family:' + F_TIT + ';font-weight:600;font-size:15px;line-height:1}' +
    '.adh-tr__stars{color:#e0a800;letter-spacing:-1px;font-size:13px}' +
    '.adh-tr__sat{font-size:12px;line-height:1.35;color:#5a4f4e}' +
    '.adh-tr__sat b{color:#251a19}' +
    '.adh-tr__q{font-size:12.5px;line-height:1.4;font-style:italic;color:#5a4f4e;margin:0 0 8px;min-height:2.8em;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;transition:opacity .4s}' +
    '.adh-tr__q span{font-style:normal;color:#8a7d7b}' +
    '.adh-tr__chips{display:flex;flex-wrap:wrap;gap:5px;margin:0}' +
    '.adh-tr__chip{display:inline-flex;align-items:center;gap:4px;background:#fff;border:1px solid #ece7e6;border-radius:999px;padding:3px 9px;font-size:11px;line-height:1.3;color:#251a19;white-space:nowrap;flex:0 0 auto}' +
    /* en el carrito lateral (pie fijo) los sellos van en una sola línea deslizable, para no robar espacio */
    '#offcanvas-cart .adh-tr__chips{flex-wrap:nowrap;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch;margin-right:-12px;padding-right:12px}' +
    '#offcanvas-cart .adh-tr__chips::-webkit-scrollbar{display:none}' +
    /* ---- Compacto: tarjeta upgrade ---- */
    '.adh-up__head{font-size:13.5px;padding:8px 12px;gap:6px}' +
    '.adh-up__head b{color:#c8604f;font-weight:600}' +
    '.adh-up__body{padding:8px 12px 10px}' +
    '.adh-up .adh-up__list{font-size:12.5px;line-height:1.35;margin:0 0 6px}' +
    '.adh-up .adh-up__list li{margin:2px 0}' +
    '.adh-up .adh-up__quote{font-size:11.5px;line-height:1.35;padding:5px 8px;margin:0 0 8px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.adh-up .adh-up__quote span{display:inline;font-size:11px;margin:0}' +
    '.adh-up .adh-up__btn{font-size:13.5px;padding:10px 12px}' +
    /* ---- Compacto: confianza SOLO en el carrito lateral (pie fijo) ----
       se oculta la reseña rotativa (sigue en la página del carrito) */
    '#offcanvas-cart .adh-tr{padding:6px 10px;margin-top:6px}' +
    '#offcanvas-cart .adh-tr__top{margin:0 0 5px;gap:6px}' +
    '#offcanvas-cart .adh-tr__score{font-size:13px}' +
    '#offcanvas-cart .adh-tr__stars{font-size:11px}' +
    '#offcanvas-cart .adh-tr__sat{font-size:11px;line-height:1.3}' +
    '#offcanvas-cart .adh-tr__q{display:none}' +
    /* en el carrito lateral la tarjeta va sin reseña, para que quepa completa con su botón */
    '#offcanvas-cart .adh-up .adh-up__quote{display:none}' +
    (OCULTAR_KACHING ? '#offcanvas-cart .kaching-icon-block--container,#cart .kaching-icon-block--container{display:none!important}' : '');
  document.head.appendChild(css);

  /* ---------- A) tarjeta upgrade ---------- */
  function upgradeHTML(d, shipLine) {
    var ahorro = d.mascaraPrice - d.diff;
    var precioMask = d.mascaraCompare
      ? ' <s>' + money(d.mascaraCompare) + '</s> ' + money(d.mascaraPrice)
      : (d.mascaraPrice ? ' ' + money(d.mascaraPrice) : '');
    /* Versión compacta: el pie fijo del carrito ocupa mucha pantalla,
       así que la oferta debe leerse completa sin hacer scroll. */
    var extras = [];
    if (ahorro > 0) extras.push('✔ Ahorras ' + money(ahorro));
    if (shipLine) extras.push(shipLine);
    return '' +
      '<div class="adh-card__head adh-up__head">✨ <span>Por <b>+' + money(d.diff) + '</b> llévate el Kit Premium</span></div>' +
      '<div class="adh-card__body adh-up__body">' +
      '<ul class="adh-up__list">' +
        '<li>💎 <strong>Máscara Golden Glow 500 g</strong>' + precioMask + '</li>' +
        '<li>🎁 Set de aplicación + Cronograma Capilar</li>' +
        (extras.length ? '<li class="adh-up__save">' + extras.join(' · ') + '</li>' : '') +
      '</ul>' +
      '<p class="adh-up__quote">“Le devolvió el brillo, la sedosidad y además prolonga mi alisado Adhara.” <span>★★★★★ Ximena A.</span></p>' +
      '<button type="button" class="adh-up__btn">Cambiar a Kit Premium (+' + money(d.diff) + ')</button>' +
      '</div>';
  }

  function premiumItem(d, qty) {
    var item = { id: d.premiumId, quantity: qty || 1 };
    if (d.pvValue) { item.properties = {}; item.properties[PV_NAME] = d.pvValue; }
    return item;
  }

  /* ---------- B) bloque envío gratis ---------- */
  /* Estilo Mercado Libre: fila horizontal de tarjetas chicas que se deslizan */
  function freeShipHTML(gap, items) {
    /* la etiqueta "✓ Envío gratis" solo se muestra si no todas completan el monto */
    var todas = items.every(function (s) { return s.price >= gap; });
    var cards = items.map(function (s, i) {
      var completa = !todas && s.price >= gap;
      return '' +
        '<div class="adh-fs__card">' +
          (completa ? '<span class="adh-fs__ok adh-pill adh-pill--green">✓ Envío gratis</span>' : '') +
          '<a href="' + esc(s.url) + '" class="adh-fs__imgwrap">' +
            (s.img ? '<img class="adh-fs__img" src="' + esc(s.img + (s.img.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<p class="adh-fs__price">' + money(s.price) + (s.compare ? ' <s>' + money(s.compare) + '</s>' : '') + '</p>' +
          '<a class="adh-fs__name" href="' + esc(s.url) + '">' + esc(s.title) + '</a>' +
          '<p class="adh-fs__ben">' + esc(s.beneficio) + '</p>' +
          (s.review ? '<p class="adh-fs__rev"><span class="adh-fs__stars">★★★★★</span> “' + esc(s.review.body) + '” <span class="adh-fs__who">' + esc(s.review.name) + '</span></p>' : '') +
          '<button type="button" class="adh-fs__btn" data-i="' + i + '">Agregar</button>' +
        '</div>';
    }).join('');
    return '' +
      '<div class="adh-card__head">🚚 <span>Agrega <b>' + money(gap) + '</b> y tu envío a domicilio es gratis</span></div>' +
      '<div class="adh-card__body">' +
      '<div class="adh-fs__wrap">' +
        '<button type="button" class="adh-fs__arrow adh-fs__arrow--prev" aria-label="Anterior" hidden>‹</button>' +
        '<div class="adh-fs__row">' + cards + '</div>' +
        '<button type="button" class="adh-fs__arrow adh-fs__arrow--next" aria-label="Siguiente">›</button>' +
      '</div>' +
      '</div>';
  }

  function wireArrows(box) {
    var row = box.querySelector('.adh-fs__row');
    var prev = box.querySelector('.adh-fs__arrow--prev');
    var next = box.querySelector('.adh-fs__arrow--next');
    if (!row || !prev || !next) return;
    function update() {
      prev.hidden = row.scrollLeft <= 4;
      next.hidden = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -158, behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: 158, behavior: 'smooth' }); });
    row.addEventListener('scroll', update, { passive: true });
    setTimeout(update, 50);
  }

  /* ---------- C) bloque de confianza: datos reales de Loox del producto principal ---------- */
  var trustCache = {};
  function loadTrust(handle) {
    if (trustCache[handle]) return trustCache[handle];
    var key = 'adhTrust:' + handle, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 30 * 60 * 1000) {
      trustCache[handle] = Promise.resolve(cached.v);
      return trustCache[handle];
    }
    trustCache[handle] = fetch('/products/' + handle).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var feed = doc.querySelector('#loox-reviews-feed');
      var val = { rating: null, count: 0, reviews: [] };
      if (feed) {
        var m = (feed.textContent || '').match(/Overall rating:\s*([\d.]+)\s*\/\s*5\s*from\s*([\d,.]+)/i);
        if (m) { val.rating = m[1]; val.count = parseInt(m[2].replace(/[^\d]/g, ''), 10) || 0; }
        var list = [];
        feed.querySelectorAll('article.loox-review').forEach(function (a) {
          var body = cleanReview((a.querySelector('.loox-review-body') || {}).textContent || '');
          var name = ((a.querySelector('.loox-reviewer-name') || {}).textContent || '').trim();
          var rating = ((a.querySelector('.loox-review-rating') || {}).textContent || '').trim();
          if (rating !== '5/5' || !a.querySelector('.loox-review-verified') || body.length < 30 || body.length > 140) return;
          list.push({ body: body, name: name, score: scoreReview(body) });
        });
        list.sort(function (x, y) { return y.score - x.score; });
        val.reviews = list.slice(0, 3).map(function (x) { return { body: x.body, name: x.name }; });
      }
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: val })); } catch (e) {}
      return val;
    }).catch(function () { return { rating: null, count: 0, reviews: [] }; });
    return trustCache[handle];
  }

  var trustTimer = null;
  function renderTrust(cart) {
    var btns = [].slice.call(document.querySelectorAll('#offcanvas-cart button[name="checkout"], #cart button[name="checkout"]'));
    document.querySelectorAll('.adh-tr').forEach(function (el) { el.parentNode.removeChild(el); });
    if (trustTimer) { clearInterval(trustTimer); trustTimer = null; }
    if (!btns.length || !cart.item_count) return;
    /* producto principal = el de mayor valor en el carrito */
    var main = cart.items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; })[0];
    loadTrust(main.handle).then(function (t) {
      document.querySelectorAll('.adh-tr').forEach(function (el) { el.parentNode.removeChild(el); });
      /* 1) puntaje + frase de satisfacción (datos reales de Loox, ver SATISFACCION)
         2) reseña real del producto principal, rotando
         3) sellos en "chips" */
      var html = '' +
        '<div class="adh-tr__top">' +
          '<span class="adh-tr__score">' + esc(SATISFACCION.promedio) + '</span>' +
          '<span class="adh-tr__stars">★★★★★</span>' +
          '<span class="adh-tr__sat"><b>El ' + SATISFACCION.pct + '% de nuestras clientas</b> califica su compra con 4 o 5★ · ' +
            esc(SATISFACCION.total) + ' reseñas</span>' +
        '</div>' +
        (t.reviews.length ? '<div class="adh-tr__q"></div>' : '') +
        '<div class="adh-tr__chips">' + SELLOS.map(function (x) {
          return '<span class="adh-tr__chip">' + x.icono + ' ' + esc(x.texto) + '</span>';
        }).join('') + '</div>';
      btns.forEach(function (btn) {
        var box = document.createElement('div');
        box.className = 'adh-tr';
        box.innerHTML = html;
        btn.parentNode.insertBefore(box, btn.nextSibling);
      });
      if (!t.reviews.length) return;
      var i = 0;
      function show() {
        var r = t.reviews[i % t.reviews.length];
        document.querySelectorAll('.adh-tr__q').forEach(function (q) {
          q.style.opacity = 0;
          setTimeout(function () {
            q.innerHTML = '“' + esc(r.body) + '” <span>— ' + esc(r.name) + ', clienta verificada</span>';
            q.style.opacity = 1;
          }, 200);
        });
        i++;
      }
      show();
      if (t.reviews.length > 1) trustTimer = setInterval(show, 6000);
    });
  }

  /* ---------- dónde mostrar ---------- */
  function targets() {
    var out = [];
    var drawerList = document.querySelector('#offcanvas-cart .offcanvas-body ul.product-list');
    if (drawerList) out.push({ list: drawerList, suf: '--drawer' });
    var pageList = document.querySelector('#cart ul.product-list');
    if (pageList) out.push({ list: pageList, suf: '--page' });
    return out;
  }
  function clearAll() {
    document.querySelectorAll('.adh-up--cart,.adh-fs--cart').forEach(function (el) { el.parentNode.removeChild(el); });
  }
  function refreshWith(res) {
    if (window.refreshCartContents) window.refreshCartContents(res); else location.reload();
  }
  function lockButtons(btn, text) {
    document.querySelectorAll('.adh-up__btn,.adh-fs__btn').forEach(function (b) { b.disabled = true; });
    btn.textContent = text;
  }

  var renderSeq = 0;
  function render() {
    if (!targets().length) return;
    var mySeq = ++renderSeq;
    Promise.all([loadUpgrade().catch(function () { return null; }), getJSON('/cart.js')]).then(function (res) {
      if (mySeq !== renderSeq) return;
      var d = res[0], cart = res[1];
      renderTrust(cart);
      var threshold = freeShipThreshold();
      var handles = cart.items.map(function (it) { return it.handle; });
      var basicoLine = null;
      if (d) cart.items.forEach(function (it) {
        if (d.basicoIds.indexOf(it.variant_id) !== -1 && !basicoLine) basicoLine = it;
      });
      var canUpgrade = d && basicoLine && d.premiumAvailable && d.diff > 0 &&
        handles.indexOf(PREMIUM) === -1 && handles.indexOf(MASCARA) === -1;

      /* A) upgrade */
      if (canUpgrade) {
        var shipLine = '';
        if (threshold) {
          var nuevoTotal = cart.total_price + d.diff * basicoLine.quantity;
          shipLine = nuevoTotal >= threshold
            ? '🚚 ¡Y envío gratis!'
            : '🚚 A ' + money(threshold - nuevoTotal) + ' del envío gratis';
        }
        clearAll();
        targets().forEach(function (t) {
          var box = document.createElement('div');
          box.className = 'adh-card adh-up adh-up--cart adh-card' + t.suf;
          box.innerHTML = upgradeHTML(d, shipLine);
          t.list.parentNode.insertBefore(box, t.list.nextSibling);
          box.querySelector('.adh-up__btn').addEventListener('click', function (e) {
            lockButtons(e.currentTarget, 'Cambiando…');
            fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: basicoLine.key, quantity: 0 })
            }).then(function () {
              return fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [premiumItem(d, basicoLine.quantity)] })
              });
            }).then(refreshWith).catch(function () { render(); });
          });
        });
        return;
      }

      /* B) envío gratis */
      var gap = threshold ? threshold - cart.total_price : 0;
      if (!cart.item_count || gap <= 0) { clearAll(); return; }
      /* El Premium ya incluye mascarilla y peineta: no se sugieren de nuevo */
      var incluidos = handles.indexOf(PREMIUM) !== -1 ? [MASCARA, 'peineta-especial-para-alisados'] : [];
      var candidatas = SUGERENCIAS.filter(function (s) {
        return handles.indexOf(s.handle) === -1 && incluidos.indexOf(s.handle) === -1;
      });
      Promise.all(candidatas.map(loadSug)).then(function (list) {
        if (mySeq !== renderSeq) return;
        var ok = list.filter(function (s) { return s && !s.preventa; });
        /* primero las que completan el envío gratis, respetando la prioridad */
        var completan = ok.filter(function (s) { return s.price >= gap; });
        var acercan = ok.filter(function (s) { return s.price < gap; });
        var items = completan.concat(acercan).slice(0, MAX_SUGERENCIAS);
        clearAll();
        if (!items.length) return;
        targets().forEach(function (t) {
          var box = document.createElement('div');
          box.className = 'adh-card adh-fs adh-fs--cart adh-card' + t.suf;
          box.innerHTML = freeShipHTML(gap, items);
          t.list.parentNode.insertBefore(box, t.list.nextSibling);
          wireArrows(box);
          box.querySelectorAll('.adh-fs__btn').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              var s = items[+e.currentTarget.getAttribute('data-i')];
              lockButtons(e.currentTarget, 'Agregando…');
              fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: s.id, quantity: 1 }] })
              }).then(refreshWith).catch(function () { render(); });
            });
          });
        });
      });
    }).catch(function () {});
  }

  window.addEventListener('updated.ecomify.cart', render);
  document.addEventListener('show.bs.offcanvas', function (e) {
    if (e.target && e.target.id === 'offcanvas-cart') render();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else { render(); }
})();

;(function adharaPreventaFicha() {
  /* ==========================================================
     ADHARA · Preventa en la ficha: cerrar 2 huecos (oct. 2026)
     En la ficha de un producto en PRE-VENTA, el campo
     "¡PRE-VENTA!📦" (aceptar la fecha) solo lo respetaba el botón
     principal "Agregar al carrito", y con un globo del navegador
     en inglés. Dos botones se lo saltaban:
       1) "Cómpralo ahora"  → iba directo al pago sin la propiedad.
       2) Barra fija inferior "Agregar al carrito" → agregaba sin ella.
     Los tres botones ahora muestran el mismo aviso en rojo, en español.
     Ahora ambos exigen aceptar la fecha y llevan la MISMA propiedad
     al carrito/pedido, así el correo de confirmación muestra el aviso.
     Productos sin preventa: no cambia nada.
     ========================================================== */
  if (window.__adhPreventaFicha) return;
  window.__adhPreventaFicha = true;

  var PV_PREFIX = 'properties[¡PRE-VENTA';

  function mainForm() {
    return document.querySelector('.product-content form[action*="/cart/add"]');
  }
  function pvInputs(form) {
    return form ? [].slice.call(form.querySelectorAll('input[name^="' + PV_PREFIX + '"]')) : [];
  }
  function pvChecked(form) {
    return pvInputs(form).filter(function (i) { return i.type !== 'radio' || i.checked; })[0] || null;
  }
  function pvFecha(form) {
    var i = pvInputs(form)[0];
    var v = i ? String(i.value) : '';
    return v.indexOf('hasta') > -1 ? v.split('hasta').pop().replace(/[?¿]/g, '').trim() : '';
  }

  var css = document.createElement('style');
  css.textContent =
    '.adh-pv-alert{outline:2px solid #e53935;outline-offset:6px;border-radius:6px;animation:adhPvShake .4s}' +
    '.adh-pv-msg{display:block;margin:8px 0 0;font-size:13px;font-weight:700;color:#c62828}' +
    '@keyframes adhPvShake{0%,100%{transform:none}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}';
  document.head.appendChild(css);

  /* Lleva a la clienta al campo de preventa y le explica qué falta */
  function pedirAceptar(form) {
    var field = (pvInputs(form)[0] || {}).closest ? pvInputs(form)[0].closest('.product-personalization-field') || pvInputs(form)[0].parentElement : null;
    if (!field) return;
    field.classList.remove('adh-pv-alert'); void field.offsetWidth; field.classList.add('adh-pv-alert');
    if (!field.querySelector('.adh-pv-msg')) {
      var m = document.createElement('span');
      m.className = 'adh-pv-msg';
      var f = pvFecha(form);
      m.textContent = '👆 Para continuar, acepta la fecha de envío de la preventa' + (f ? ' (desde el ' + f + ')' : '') + '.';
      field.appendChild(m);
    }
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    /* respaldo: si el desplazamiento suave no se completó (algunos navegadores/apps), salto directo */
    setTimeout(function () {
      var r = field.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) field.scrollIntoView({ behavior: 'instant', block: 'center' });
    }, 700);
  }

  /* Cuando acepta, se quita la alerta */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name || t.name.indexOf(PV_PREFIX) !== 0) return;
    var field = t.closest('.product-personalization-field') || t.parentElement;
    if (field) {
      field.classList.remove('adh-pv-alert');
      var m = field.querySelector('.adh-pv-msg'); if (m) m.parentNode.removeChild(m);
    }
  }, true);

  /* 0) Botón principal "Agregar al carrito": el navegador mostraba su
        globo estándar ("Please select one of these options", en el idioma
        del navegador). Se reemplaza por el mismo aviso en rojo de Adhara. */
  document.addEventListener('invalid', function (e) {
    var t = e.target;
    if (!t || !t.name || t.name.indexOf(PV_PREFIX) !== 0) return;
    e.preventDefault(); /* oculta el globo del navegador; el envío igual queda bloqueado */
    var form = t.form || t.closest('form');
    if (form) pedirAceptar(form);
  }, true);

  /* 1) "Cómpralo ahora": se intercepta antes que el botón del tema */
  window.__adhPvGoCheckout = window.__adhPvGoCheckout || function () { window.location.href = '/checkout'; };
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.btn-buy') : null;
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || form !== mainForm() || !pvInputs(form).length) return; /* sin preventa: comportamiento normal */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!pvChecked(form)) { pedirAceptar(form); return; }
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Cargando…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.__adhPvGoCheckout(); })
      .catch(function () { btn.disabled = false; btn.innerHTML = original; });
  }, true);

  /* 2) Barra fija (u otro formulario del MISMO producto sin el campo) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var main = mainForm();
    if (!main || form === main || !pvInputs(main).length) return;
    if (pvInputs(form).length) return; /* ya trae su propio campo */
    var idF = (form.querySelector('[name="id"]') || {}).value;
    var idM = (main.querySelector('[name="id"]') || {}).value;
    if (!idF || idF !== idM) return; /* es otro producto (recomendados, etc.) */
    var ok = pvChecked(main);
    if (!ok) {
      e.preventDefault();
      e.stopImmediatePropagation();
      pedirAceptar(main);
      return;
    }
    /* copia la aceptación al formulario de la barra antes de enviarlo */
    var h = form.querySelector('input[data-adh-pv]');
    if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.setAttribute('data-adh-pv', '1'); form.appendChild(h); }
    h.name = ok.name;
    h.value = ok.value;
  }, true);
})();

/* ===== INICIO adharaResumen ===== */
;(function adharaResumen() {
  /* ==========================================================
     ADHARA · Resumen que cierra (Base 360 · oct. 2026)
     Reemplaza el "Subtotal" del carrito lateral y de /cart por un
     resumen estilo Mercado Libre, con el despacho incluido:
       Productos (2)                  $214,583   ← solo en /cart
       Descuentos                     −$48,842   ← solo en /cart
       Total                          $165,741
                             Ahorras $48,842
       09:00–18:30:  ⚡ Santiago: hoy con Express Uber (máx. 2 h) o mañana · desde $3,290
                     📦 Regiones: jue 22 – mar 27 · desde $3,990
       resto:        🚚 Santiago: llega mañana · desde $3,290
                     📦 Regiones: jue 22 – mar 27 · desde $3,990
       Sobre $70.000 el "desde $X" pasa a "gratis" (verde).
     Botón "Pagar" → "Continuar compra · $165,741".
     Reemplaza al bloque adharaEntrega (no dejar los dos).
     Cambios 28-oct-2026:
       - Express de 09:00 a 18:30, entrega máx. 2 h en la RM (dato de Eugenio),
         igual que el recuadro de la ficha (adharaEntregaFicha).
       - PRE-VENTA vencida: si la fecha de la preventa ya llegó (o pasó), el carrito
         ya no dice "Tu pedido incluye preventa" y muestra el despacho normal.
         Antes, un producto agregado cuando estaba en preventa seguía mostrando
         el aviso aunque la preventa ya hubiera terminado.
     Respaldo de los textos:
       - Precios y descuentos: /cart.js + precio normal de cada producto.
       - Envío gratis: monto meta de la barra del tema ($70.000).
         Bajo el monto: "desde $3,290" (Santiago) y "desde $3,990" (regiones), tarifas reales
         del checkout según la tabla vigente de Amplifica; actualizar si cambian.
       - Regiones: corte 14:00 + Blue Express al día siguiente. Tiempos reales
         may–oct 2026: mediana 3,7 días y 80% en ≤6 días corridos.
     FERIADOS: actualizar cada año.
     ========================================================== */
  if (window.__adhResumen) return;
  window.__adhResumen = true;

  /* ---------- fechas de despacho ---------- */
  var CORTE = 14;            /* regiones: corte de preparación Amplifica */
  var EXPRESS = [9, 18.5];   /* Express Uber: 09:00 a 18:30 */
  var RANGO = { reg: [2, 5] }; /* regiones: días hábiles después de despachar */
  var TARIFA = { stgo: 329000, reg: 399000 };
  var FERIADOS = ['2026-10-31','2026-11-01','2026-12-08','2026-12-25',
    '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21','2027-06-21','2027-06-28',
    '2027-07-16','2027-08-15','2027-09-17','2027-09-18','2027-09-19','2027-10-11','2027-10-31',
    '2027-11-01','2027-12-08','2027-12-25'];
  var DIAS = ['dom','lun','mar','mié','jue','vie','sáb'];
  var MES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  var MESES_LARGOS = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function ahoraCL() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' })); }
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function habil(d) { var w = d.getDay(); return w > 0 && w < 6 && FERIADOS.indexOf(iso(d)) < 0; }
  function sumarHabiles(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (habil(x)) n--; } return x; }
  function siguienteHabil(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!habil(x)); return x; }
  function fecha(d) { return DIAS[d.getDay()] + ' ' + d.getDate(); }
  function rango(a, b) {
    var cruza = a.getMonth() !== b.getMonth();
    return '<b>' + fecha(a) + (cruza ? ' ' + MES[a.getMonth()] : '') + ' – ' + fecha(b) + (cruza ? ' ' + MES[b.getMonth()] : '') + '</b>';
  }
  function entregaStgo(now) {
    var x = new Date(now);
    do { x.setDate(x.getDate() + 1); } while (x.getDay() === 0 || FERIADOS.indexOf(iso(x)) > -1);
    var manana = new Date(now); manana.setDate(now.getDate() + 1);
    return iso(x) === iso(manana) ? '<b>mañana</b>' : 'el <b>' + fecha(x) + '</b>';
  }
  /* "28 de Octubre" → true si esa fecha ya llegó (hoy o antes). Si no se entiende, false. */
  function preventaVencida(txt) {
    var m = String(txt).toLowerCase().match(/(\d{1,2})\s*(?:de\s*)?([a-záéíóú]+)/);
    if (!m) return false;
    var mes = MESES_LARGOS.indexOf(m[2].replace('setiembre', 'septiembre'));
    if (mes < 0) return false;
    var now = ahoraCL();
    var f = new Date(now.getFullYear(), mes, parseInt(m[1], 10));
    /* fechas de enero vistas en diciembre: son del año siguiente */
    if (now.getMonth() === 11 && mes === 0) f.setFullYear(now.getFullYear() + 1);
    var hoy = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return f <= hoy;
  }
  function precio(gratis, tarifa) {
    return gratis ? '<b class="adh-res__g">gratis</b>' : 'desde <b>' + money(tarifa) + '</b>';
  }
  function despacho(gratis) {
    var now = ahoraCL();
    var h = now.getHours() + now.getMinutes() / 60;
    var express = h >= EXPRESS[0] && h < EXPRESS[1] && FERIADOS.indexOf(iso(now)) < 0;
    var hoy = habil(now) && now.getHours() < CORTE;
    var sale = hoy ? new Date(now) : siguienteHabil(now); /* regiones: Blue Express */
    var l1 = express
      ? '⚡ Santiago: <b>hoy</b> con Express Uber (máx. 2 h) o ' + entregaStgo(now) + ' · ' + precio(gratis, TARIFA.stgo)
      : '🚚 Santiago: llega ' + entregaStgo(now) + ' · ' + precio(gratis, TARIFA.stgo);
    var l2 = '📦 Regiones: ' + rango(sumarHabiles(sale, RANGO.reg[0]), sumarHabiles(sale, RANGO.reg[1])) + ' · ' + precio(gratis, TARIFA.reg);
    return '<p>' + l1 + '</p><p>' + l2 + '</p>';
  }

  /* ---------- precios ---------- */
  function money(c) { return '$' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function metaEnvio() {
    var bar = document.querySelector('#cart-goal [aria-valuemax]');
    var v = bar ? parseInt(String(bar.getAttribute('aria-valuemax')).replace(/\D/g, ''), 10) : 0;
    return (v || 70000) * 100;
  }
  var normales = {}; /* variant_id → precio normal (compare_at) */
  try { normales = JSON.parse(sessionStorage.getItem('adhNormales') || '{}'); } catch (e) {}
  function cargarNormales(items) {
    var faltan = items.filter(function (it) { return !(it.variant_id in normales); });
    var handles = faltan.map(function (it) { return it.handle; }).filter(function (h, i, a) { return a.indexOf(h) === i; });
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        p.variants.forEach(function (v) { normales[v.id] = Math.max(v.compare_at_price || 0, v.price || 0); });
      }).catch(function () {});
    })).then(function () {
      faltan.forEach(function (it) { if (!(it.variant_id in normales)) normales[it.variant_id] = it.original_price; });
      try { sessionStorage.setItem('adhNormales', JSON.stringify(normales)); } catch (e) {}
    });
  }

  var estado = null; /* {n, normal, total, pv} */
  function leerCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c.item_count) { estado = null; pintar(); return; }
      return cargarNormales(c.items).then(function () {
        var normal = 0, pv = '';
        c.items.forEach(function (it) {
          var base = it.final_line_price === 0 ? it.original_price : Math.max(normales[it.variant_id] || 0, it.original_price);
          normal += base * it.quantity;
          Object.keys(it.properties || {}).forEach(function (k) {
            if (k.indexOf('PRE-VENTA') < 0) return;
            var v = String(it.properties[k]);
            var f = v.indexOf('hasta') > -1 ? v.split('hasta').pop().replace(/[?¿]/g, '').trim() : '';
            if (f && preventaVencida(f)) return; /* la preventa ya terminó: despacho normal */
            pv = f || pv || 'la fecha de preventa';
          });
        });
        estado = { n: c.item_count, normal: normal, total: c.total_price, pv: pv };
        pintar();
      });
    }).catch(function () {});
  }

  /* ---------- diseño ---------- */
  var css = document.createElement('style');
  css.textContent =
    '.adh-res{font-family:Lato,sans-serif;font-size:14px;color:#5a4f4e;margin:0 0 12px;text-align:left}' +
    '.adh-res__row{display:flex;justify-content:space-between;margin:0 0 5px}' +
    '.adh-res__g{color:#1e7b34;font-weight:700}' +
    '.adh-res__tot{display:flex;justify-content:space-between;align-items:baseline;margin:6px 0 0;padding-top:6px;border-top:1px solid #ece7e6;font:700 18px Poppins,sans-serif;color:#251a19}' +
    '.adh-res__tot--first{border-top:0;margin-top:0;padding-top:0}' +
    '.adh-res__sav{text-align:right;color:#1e7b34;font-weight:700;font-size:13.5px;margin:2px 0 0}' +
    '#offcanvas-cart .adh-res{font-size:13.5px;margin:0 0 10px}' +
    '.adh-res__del{margin:8px 0 0;padding:9px 11px;background:#faf7f6;border-radius:10px;font-size:12.5px;line-height:1.45}' +
    '.adh-res__del p{margin:0 0 2px}.adh-res__del b,.adh-res b{color:#251a19}';
  document.head.appendChild(css);

  function html(compacto) {
    var e = estado, desc = e.normal - e.total, gratis = e.total >= metaEnvio();
    var del = e.pv
      ? '<p>📦 Tu pedido incluye <b>preventa</b>: sale desde el <b>' + e.pv + '</b></p>' +
        '<p>🚚 Envío: Santiago ' + precio(gratis, TARIFA.stgo) + ' · Regiones ' + precio(gratis, TARIFA.reg) + '</p>'
      : despacho(gratis);
    return (compacto ? '' : '<p class="adh-res__row"><span>Productos (' + e.n + ')</span><span>' + money(e.normal) + '</span></p>' +
      (desc > 0 ? '<p class="adh-res__row"><span>Descuentos</span><span class="adh-res__g">−' + money(desc) + '</span></p>' : '')) +
      '<p class="adh-res__tot' + (compacto ? ' adh-res__tot--first' : '') + '"><span>Total</span><span>' + money(e.total) + '</span></p>' +
      (desc > 0 ? '<p class="adh-res__sav">Ahorras ' + money(desc) + '</p>' : '') +
      '<div class="adh-res__del">' + del + '</div>';
  }

  function pintar() {
    ['#offcanvas-cart-subtotal', '#cart-subtotal'].forEach(function (sel) {
      var sub = document.querySelector(sel);
      if (!sub) return;
      var el = sub.nextElementSibling && sub.nextElementSibling.classList.contains('adh-res') ? sub.nextElementSibling : null;
      var nota = sel === '#offcanvas-cart-subtotal' ? (function () {
        var n = el ? el.nextElementSibling : sub.nextElementSibling;
        return n && /calculados al momento de pagar/i.test(n.textContent) ? n : null;
      })() : null;
      var form = sub.parentNode.querySelector('button[name="checkout"]');
      if (!estado) {
        sub.style.removeProperty('display'); if (nota) nota.style.removeProperty('display');
        if (el) el.parentNode.removeChild(el);
        return;
      }
      sub.style.setProperty('display', 'none', 'important'); if (nota) nota.style.setProperty('display', 'none', 'important');
      if (!el) { el = document.createElement('div'); el.className = 'adh-res'; sub.parentNode.insertBefore(el, sub.nextSibling); }
      var h = html(sel === '#offcanvas-cart-subtotal');
      if (el.innerHTML !== h) el.innerHTML = h;
      if (form) {
        var txt = [].filter.call(form.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })[0];
        var nuevo = ' Continuar compra · ' + money(estado.total) + ' ';
        if (txt && txt.textContent !== nuevo) txt.textContent = nuevo;
      }
    });
  }

  var t, visto = '';
  new MutationObserver(function (muts) {
    if (muts.every(function (m) { var n = m.target.nodeType === 3 ? m.target.parentNode : m.target; return n && n.closest && (n.closest('.adh-res') || n.closest('button[name="checkout"]')); })) return;
    clearTimeout(t); t = setTimeout(function () {
      var sub = document.querySelector('#offcanvas-cart-subtotal, #cart-subtotal');
      var v = sub ? sub.textContent.replace(/\D/g, '') : '';
      if (v !== visto) { visto = v; leerCarrito(); } else pintar();
    }, 250);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('updated.ecomify.cart', leerCarrito);
  document.addEventListener('shown.bs.offcanvas', leerCarrito);
  setInterval(pintar, 30000);
  leerCarrito();
})();
/* ===== FIN adharaResumen ===== */

;(function adharaCarritoLimpio() {
  /* ==========================================================
     ADHARA · Carrito limpio (Base 360 · oct. 2026)
     1) Barra de envío gratis: coral mientras falta, VERDE al llegar al monto
        (también el ícono del camión).
     2) Con el carrito lateral abierto y en la página /cart oculta lo que
        tapa "Continuar compra":
        - botones flotantes de Chat (Shopify Inbox) y WhatsApp (Pushdaddy)
        - barra fija "Agregar al carrito" de la ficha (#sticky-atc-bar)
        - popups de Sale Kit (Qikify: "X compró…", campañas). La barra
          superior de promoción (cuotas VENTI) se mantiene.
        Al cerrar el carrito todo vuelve a la normalidad.
        En el checkout no aparecen: Shopify no permite apps ahí.
     ========================================================== */
  if (window.__adhCarritoLimpio) return;
  window.__adhCarritoLimpio = true;

  var css = document.createElement('style');
  css.textContent =
    /* 1) barra verde al lograr el envío gratis */
    '#cart-goal.adh-goal-ok .progress-bar{background:#2e9e4a !important;background-image:none !important;animation:none !important}' +
    '#cart-goal.adh-goal-ok .cart-goal-icon{background:#2e9e4a !important}' +
    /* 2) sin flotantes en el carrito */
    'body.adh-sin-flotantes shopify-chat,body.adh-sin-flotantes #pushdaddy-button,' +
    'body.adh-sin-flotantes #sticky-atc-bar,' +
    'body.adh-sin-flotantes #qikify-salekit .qikify-salekit-app > :not(.qsk-promobar){display:none !important}';
  document.head.appendChild(css);

  /* 1) marca la meta como lograda cuando la barra está al 100% */
  function revisarMeta() {
    [].forEach.call(document.querySelectorAll('#cart-goal'), function (g) {
      var bar = g.querySelector('.progress-bar');
      if (!bar) return;
      var ancho = bar.getAttribute('data-width') || bar.style.width || '';
      var ok = parseFloat(ancho) >= 100;
      if (g.classList.contains('adh-goal-ok') !== ok) g.classList.toggle('adh-goal-ok', ok);
    });
  }

  /* 2) flotantes: fuera mientras el carrito está a la vista */
  var enCart = /^\/cart\/?$/.test(location.pathname);
  function flotantes() {
    var drawer = document.querySelector('#offcanvas-cart.show, #offcanvas-cart.showing');
    var ocultar = enCart || !!drawer;
    if (document.body.classList.contains('adh-sin-flotantes') !== ocultar) document.body.classList.toggle('adh-sin-flotantes', ocultar);
  }

  var t;
  function todo() { revisarMeta(); flotantes(); }
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(todo, 100); })
    .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'data-width'] });
  document.addEventListener('show.bs.offcanvas', function (e) { if (e.target && e.target.id === 'offcanvas-cart') document.body.classList.add('adh-sin-flotantes'); });
  document.addEventListener('hidden.bs.offcanvas', function (e) { if (e.target && e.target.id === 'offcanvas-cart') flotantes(); });
  todo();
})();
/* ===== INICIO adharaEntregaFicha ===== */
;(function adharaEntregaFicha() {
  /* ==========================================================
     ADHARA · Entrega en la ficha de producto (Base 360 · oct. 2026)
     Recuadro verde bajo "Cómpralo ahora" que cambia según la hora de Chile:
       09:00–18:30  ⚡ Santiago: recíbelo HOY con Express Uber · máx. 2 horas
                    (cuenta regresiva: "pide en las próximas 3 h 20 min")
                    🚚 o con envío estándar llega mañana · 📦 Regiones: jue 29 – mar 3
       antes 09:00  ⚡ Desde las 09:00 recíbelo hoy con Express Uber (máx. 2 h)
       después      🚚 Santiago: llega mañana · ⚡ mañana desde las 09:00, Express en 2 h
     Datos (Eugenio, 28-oct-2026): Express Uber de 09:00 a 18:30, entrega máx. 2 h en la RM.
     Estándar Santiago: lo que promete el checkout ("Llega MAÑANA", lunes a sábado).
     Regiones: corte 14:00 + 2 a 5 días hábiles (igual que el carrito).
     No aparece si el producto está agotado o en preventa.
     FERIADOS: actualizar cada año (misma lista que adharaResumen).
     ========================================================== */
  if (window.__adhEntregaFicha) return;
  window.__adhEntregaFicha = true;
  if (!/\/products\//.test(location.pathname)) return;

  var EXPRESS = [9, 18.5];       /* 09:00 a 18:30 */
  var CORTE = 14;                /* regiones */
  var RANGO = [2, 5];            /* regiones: días hábiles desde el despacho */
  var EXPRESS_DOMINGO = true;    /* cambiar a false si Uber Express no opera domingo */
  var FERIADOS = ['2026-10-31','2026-11-01','2026-12-08','2026-12-25',
    '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21','2027-06-21','2027-06-28',
    '2027-07-16','2027-08-15','2027-09-17','2027-09-18','2027-09-19','2027-10-11','2027-10-31',
    '2027-11-01','2027-12-08','2027-12-25'];
  var DIAS = ['dom','lun','mar','mié','jue','vie','sáb'];
  var MES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

  function ahoraCL() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' })); }
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function feriado(d) { return FERIADOS.indexOf(iso(d)) > -1; }
  function habil(d) { var w = d.getDay(); return w > 0 && w < 6 && !feriado(d); }
  function sumarHabiles(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (habil(x)) n--; } return x; }
  function siguienteHabil(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!habil(x)); return x; }
  function fecha(d) { return DIAS[d.getDay()] + ' ' + d.getDate(); }
  function rango(a, b) {
    var cruza = a.getMonth() !== b.getMonth();
    return fecha(a) + (cruza ? ' ' + MES[a.getMonth()] : '') + ' – ' + fecha(b) + (cruza ? ' ' + MES[b.getMonth()] : '');
  }
  function entregaStgo(now) { /* estándar: día siguiente, lunes a sábado */
    var x = new Date(now);
    do { x.setDate(x.getDate() + 1); } while (x.getDay() === 0 || feriado(x));
    var m = new Date(now); m.setDate(now.getDate() + 1);
    return iso(x) === iso(m) ? 'mañana' : 'el ' + fecha(x);
  }
  function expressHoy(d) { return !feriado(d) && (EXPRESS_DOMINGO || d.getDay() !== 0); }
  function quedan(h) {
    var min = Math.max(0, Math.round((EXPRESS[1] - h) * 60));
    var hh = Math.floor(min / 60), mm = min % 60;
    return (hh ? hh + ' h ' : '') + mm + ' min';
  }

  function contenido() {
    var now = ahoraCL(), h = now.getHours() + now.getMinutes() / 60;
    var sale = (habil(now) && now.getHours() < CORTE) ? new Date(now) : siguienteHabil(now);
    var reg = '📦 <b>Regiones:</b> ' + rango(sumarHabiles(sale, RANGO[0]), sumarHabiles(sale, RANGO[1]));
    var std = entregaStgo(now);
    if (expressHoy(now) && h >= EXPRESS[0] && h < EXPRESS[1]) {
      return '<p class="adh-ent__big">⚡ <b>Santiago: recíbelo HOY</b> con Express Uber · máx. 2 horas</p>' +
             '<p class="adh-ent__sub">Pide en las próximas <b>' + quedan(h) + '</b> · o con envío estándar llega ' + std + '</p>' +
             '<p class="adh-ent__sub">' + reg + '</p>';
    }
    if (expressHoy(now) && h < EXPRESS[0]) {
      return '<p class="adh-ent__big">⚡ <b>Santiago: recíbelo HOY</b> con Express Uber desde las 09:00 · máx. 2 horas</p>' +
             '<p class="adh-ent__sub">o con envío estándar llega ' + std + ' · ' + reg + '</p>';
    }
    var man = new Date(now); man.setDate(now.getDate() + 1);
    var expMan = expressHoy(man) ? ' · o mañana desde las 09:00 con Express en 2 horas' : '';
    return '<p class="adh-ent__big">🚚 <b>Santiago: llega ' + std + '</b> con envío estándar</p>' +
           '<p class="adh-ent__sub">' + reg + expMan + '</p>';
  }

  var css = document.createElement('style');
  css.textContent =
    '.adh-ent{margin:12px 0 0;padding:10px 13px;border-radius:10px;background:#f3faf5;border:1px solid #dcefe2;font-family:Lato,sans-serif;color:#1e5b2e;text-align:left}' +
    '.adh-ent p{margin:0}.adh-ent b{color:#174a25}' +
    '.adh-ent__big{font-size:15px;line-height:1.4}' +
    '.adh-ent__sub{font-size:13.5px;line-height:1.45;color:#2f5e3c;margin-top:3px!important}';
  document.head.appendChild(css);

  function enPreventa(box) {
    var form = box.closest('form') || document;
    return [].some.call(form.querySelectorAll('[name^="properties"]'), function (i) { return /PRE-VENTA/i.test(i.name); });
  }
  function pintar() {
    var box = document.querySelector('main .product-buy-buttons');
    if (!box) return;
    var atc = box.closest('form') && box.closest('form').querySelector('button[name="add"]');
    var el = box.querySelector('.adh-ent');
    var ocultar = (atc && atc.disabled) || enPreventa(box);
    if (ocultar) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) { el = document.createElement('div'); el.className = 'adh-ent'; box.appendChild(el); }
    var h = contenido();
    if (el.innerHTML !== h) el.innerHTML = h;
  }
  pintar();
  setInterval(pintar, 30000); /* cuenta regresiva y cambio de horario */
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('main form')) setTimeout(pintar, 300); });
})();
/* ===== FIN adharaEntregaFicha ===== */
